export const ru = {
    notifications: 'Оповещения'
};
